import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { Translator } from "components/i18n";

import { Sidebar } from "../icons/Sidebar";
import { useSidebar } from "../ui/sidebar";
import { useTheme } from "../ThemeProvider";
import { useCarstenTheme } from "../LeftSidebar/ThreadList";

export default function SidebarTrigger({
  label = false,
  className = "",
}: {
  label?: boolean;
  className?: string;
}) {
  const { setOpen, open, openMobile, setOpenMobile, isMobile } = useSidebar();
  const { variant } = useTheme();
  const CarstenStyles = useCarstenTheme();
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            id="sidebar-trigger-button"
            onClick={() => isMobile ? setOpenMobile(!openMobile) : setOpen(!open)}
            size="icon"
            variant="ghost"
            className={`
                        flex items-center justify-start
                         w-full
                         h-11
                        rounded-sm
                        ${CarstenStyles.sidebar.background.default} 
                        ${CarstenStyles.sidebar.background.hover}
                        ${className}
                      `}
          >
            <span className={`
                            flex-shrink-0
                            rounded
    flex
    justify-center items-center w-[44px] h-[44px]
                             ${CarstenStyles.sidebar.icon.default} 
                            ${CarstenStyles.sidebar.icon.hover}
                          `}>
              <Sidebar className="size-6" />
            </span>

            {label && (
              <span className={`
                            ml-2
                            whitespace-nowrap
                            rounded
                            ${CarstenStyles.sidebar.text.active} 
                            ${CarstenStyles.sidebar.text.default} 
                            ${CarstenStyles.sidebar.text.hover}
                          `}>
                Close Sidebar
              </span>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>
            {open ? (
              <Translator
                className={`${CarstenStyles.sidebar.text.active}
                                        ${CarstenStyles.sidebar.text.default}
                                        ${CarstenStyles.sidebar.text.hover}
                `}
                path="threadHistory.sidebar.actions.close"
              />
            ) : (
              <Translator
                className={`${CarstenStyles.sidebar.text.active}
                                        ${CarstenStyles.sidebar.text.default}
                                        ${CarstenStyles.sidebar.text.hover}
                `}
                path="threadHistory.sidebar.actions.open"
              />
            )}
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider >
  );
}
